"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicRoutes = exports.DonorRoutes = exports.OrganizationRoutes = exports.CampaignPaymentTab = exports.SignInQueryParams = exports.DONOR_PAYMENT_DRAWER_CONTROL_QUERY_PARAM = exports.parseResetPasswordLinkContext = exports.formatResetPasswordLinkContext = exports.RESET_PASSWORD_LINK_CONTEXT_QUERY_PARAM = exports.IS_SUPER_ADMIN_QUERY_PARAM = exports.SHOW_SUCCESS_BANK_MODALE_QUERY_PARAM = exports.getIndividualFundraisingLink = exports.getTeamLink = exports.getEmbedTicketingLink = exports.getOrganizationPageFullUrl = exports.getOrganizationPageNewsletterUrl = exports.getOrganizationPageLink = exports.getTicketingLink = exports.getEmbedLeaderboardLink = exports.getLiveThermometerLink = exports.getEmbedThermometerLink = exports.getEmbedFormLink = exports.getDonationOrTicketingEmbedLink = exports.getDonationOrTicketingFormLink = exports.getFormLink = exports.PeerToPeerQueryParams = exports.FormQueryParams = exports.MobileRoutes = exports.EMAIL_DRAFT_CARRYING_ROUTES = exports.DashboardRoutes = exports.FrontendRoutes = exports.RouteBuilders = exports.buildPathFromTemplate = exports.BuiltRoute = exports.MY_TEMPLATES_GALLERY_SEARCH_PARAMS = exports.RoutesParams = exports.RoutePrefix = void 0;
const query_string_1 = require("query-string");
const enums_1 = require("../enums");
const locales_1 = require("../internationalization/features/locales");
const links_1 = require("../internationalization/locales/links");
var RoutePrefix;
(function (RoutePrefix) {
    RoutePrefix["Organization"] = "/o";
    RoutePrefix["Donor"] = "/d";
})(RoutePrefix || (exports.RoutePrefix = RoutePrefix = {}));
var RoutesParams;
(function (RoutesParams) {
    RoutesParams["RelaunchStripeOnboarding"] = "relaunchStripeOnboarding";
    RoutesParams["StripeOnboardingSucceeded"] = "stripeOnboardingSucceeded";
})(RoutesParams || (exports.RoutesParams = RoutesParams = {}));
exports.MY_TEMPLATES_GALLERY_SEARCH_PARAMS = { isCreationFlow: "true", templateFilter: "organization" };
const buildMagicEmailSearchParams = (params) => ({
    ...(params?.emailContentId ? { emailContentId: params.emailContentId } : {}),
    ...(params?.entryPoint ? { entryPoint: params.entryPoint } : {}),
    ...(params?.onExitUrl ? { onExitUrl: params.onExitUrl } : {}),
});
class BuiltRoute {
    path;
    searchParams = {};
    constructor(path) {
        this.path = path;
    }
    addSearchParams(searchParams) {
        this.searchParams = { ...this.searchParams, ...searchParams };
        return this;
    }
    // method to return the path with the search params
    toString() {
        const searchParamsString = new URLSearchParams(this.searchParams).toString();
        return searchParamsString ? `${this.path}?${searchParamsString}` : this.path;
    }
}
exports.BuiltRoute = BuiltRoute;
const buildPathFromTemplate = (template, params) => {
    let output = template;
    for (const [key, value] of Object.entries(params)) {
        if (value) {
            output = output.replace(new RegExp(`\\[(.*?):${key}(.*?)\\]`, "gi"), `$1${value}$2`); // Replace optional parameter
            output = output.replace(new RegExp(`:${key}`, "gi"), value); // Replace required parameter
        }
        else {
            output = output.replace(new RegExp(`(\\[.*?:${key}.*?\\])`, "gi"), ""); // Remove optional parameter
        }
    }
    return new BuiltRoute(output);
};
exports.buildPathFromTemplate = buildPathFromTemplate;
exports.RouteBuilders = {
    homePageFreePlatformUrl: (params) => {
        return new BuiltRoute(links_1.HomePageFreePlatformUrl[params.locale]);
    },
    buildCreateNewFormLink: (params) => (0, exports.buildPathFromTemplate)(`/:isoLocale${exports.OrganizationRoutes.FormsNew}`, params),
    buildCheckInManagerUrl: (params) => {
        return (0, exports.buildPathFromTemplate)(`/:isoLocale/checkin-manager/:token`, params);
    },
    buildEventTicketsUrl: (params) => {
        return (0, exports.buildPathFromTemplate)(`/:isoLocale/event-tickets/:token`, params);
    },
    buildCancelAttendanceUrl: (params) => {
        return (0, exports.buildPathFromTemplate)(`/:isoLocale/cancel-attendance/:token`, params);
    },
    buildAppleWalletPassDownloadUrl: (params) => {
        return (0, exports.buildPathFromTemplate)(`/:isoLocale/wallet-pass/apple/:token`, params);
    },
    buildCreateNewDonationFormLink: () => {
        return new BuiltRoute(exports.OrganizationRoutes.DonationFormsNew);
    },
    buildCreateNewTicketingFormLink: () => {
        return new BuiltRoute(exports.OrganizationRoutes.TicketingNew);
    },
    /** Opens the creation flow with an existing form id (e.g. after duplicate). */
    buildDonationFormNewWithIdLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/o/donations/forms/new`, params).addSearchParams({
        donationFormId: params.formId,
    }),
    /** Opens the creation flow with an existing form id (e.g. after duplicate). */
    buildTicketingFormNewWithIdLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/o/tickets/forms/new`, params).addSearchParams({
        ticketingId: params.formId,
    }),
    buildDashboardHomePageUrl: (params) => {
        const route = new BuiltRoute("/o/insights");
        if (params?.campaignId) {
            route.addSearchParams({ campaignId: params.campaignId });
        }
        return route;
    },
    buildMemberInsightsPageUrl: (params) => {
        const route = new BuiltRoute("/o/insights/members");
        if (params?.campaignId) {
            route.addSearchParams({ campaignId: params.campaignId });
        }
        return route;
    },
    buildDonorHomePageUrl: (params) => {
        return (0, exports.buildPathFromTemplate)("/:isoLocale/d/payments", params);
    },
    buildDonorCampaignListLink: (params) => {
        return (0, exports.buildPathFromTemplate)("[/:isoLocale]/d/campaigns", params);
    },
    buildDonorDonationFormEditLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/d/donations/forms/edit`, params).addSearchParams({
        donationFormId: params.formId,
        ...(params.backToDashboardUrl && { backToDashboardUrl: params.backToDashboardUrl }),
    }),
    buildPeerToPeerV2CampaignLink: (params) => {
        const { type, isEmbedV2, ...rest } = params;
        if (isEmbedV2) {
            return exports.RouteBuilders.buildEmbedPeerToPeerV2CampaignLink(rest);
        }
        if (type === "general") {
            return exports.RouteBuilders.buildPeerToPeerV2GeneralCampaignLink(rest);
        }
        if (type === "team") {
            return exports.RouteBuilders.buildPeerToPeerV2TeamCampaignLink(rest);
        }
        return exports.RouteBuilders.buildPeerToPeerV2IndividualCampaignLink(rest);
    },
    buildCampaignListLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/o/fundraising/campaigns`, params).addSearchParams({
        ...(params.search && { search: params.search }),
        ...(params.status && { status: params.status }),
    }),
    buildCampaignHubTabLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/o/fundraising/campaigns/hub`, params).addSearchParams({
        formId: params.formId,
        tab: params.tab,
    }),
    buildDonationFormEditLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/o/donations/forms/edit`, params).addSearchParams({
        donationFormId: params.formId,
        ...(params.onExitUrl && { onExitUrl: params.onExitUrl }),
    }),
    buildTicketingFormEditLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/o/tickets/forms/edit`, params).addSearchParams({
        ticketingId: params.formId,
        ...(params.onExitUrl && { onExitUrl: params.onExitUrl }),
    }),
    buildPeerToPeerV2GeneralCampaignLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]${FrontendRoutes.PeerToPeerPage}:path`, params),
    buildPeerToPeerV2TeamCampaignLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]${FrontendRoutes.TeamPage}:path`, params),
    buildPeerToPeerV2IndividualCampaignLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]${FrontendRoutes.FundraisingPage}:path`, params),
    buildEmbedPeerToPeerV2CampaignLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/embed${FrontendRoutes.DonationFormPage}:path`, params),
    buildDonationFormLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]${FrontendRoutes.DonationFormPage}:path`, params),
    buildEmbedDonationFormLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/embed${FrontendRoutes.DonationFormPage}:path`, params),
    buildTicketingFormLink: (params) => {
        const { isEmbedV2, ...rest } = params;
        const route = isEmbedV2
            ? `[/:isoLocale]/embed${FrontendRoutes.TicketingPage}:ticketingId`
            : `[/:isoLocale]${FrontendRoutes.TicketingPage}:ticketingId`;
        return (0, exports.buildPathFromTemplate)(route, rest);
    },
    buildOrganizationPageLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]${FrontendRoutes.OrganizationPage}:path`, params),
    buildNewsletterFormLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]${FrontendRoutes.NewsletterFormPage}:path`, params),
    buildEmbedNewsletterFormLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/embed${FrontendRoutes.NewsletterFormPage}:path`, params),
    buildContactListsCreateLink: () => new BuiltRoute(exports.OrganizationRoutes.ContactListsCreate),
    buildContactListsNewLink: (params) => {
        const route = new BuiltRoute(exports.OrganizationRoutes.ContactListsNew);
        return params?.type ? route.addSearchParams({ type: params.type }) : route;
    },
    buildContactListsLink: (params) => (0, exports.buildPathFromTemplate)(`${exports.OrganizationRoutes.ContactLists}[/:contactListId]`, {
        contactListId: params?.contactListId ?? null,
    }),
    buildMembersListLink: (params) => {
        const route = new BuiltRoute(exports.OrganizationRoutes.Members);
        if (params?.membershipStatus?.length) {
            route.addSearchParams({ membershipStatus: params.membershipStatus.join(",") });
        }
        if (params?.autoRenew?.length) {
            route.addSearchParams({ autoRenew: params.autoRenew.join(",") });
        }
        if (params?.expiredSinceDays) {
            route.addSearchParams({ expiredSinceDays: params.expiredSinceDays.toString() });
        }
        return route;
    },
    buildContactDrawerLink: (params) => new BuiltRoute(exports.OrganizationRoutes.Contacts).addSearchParams({ contactId: params.contactId }),
    buildCompanyDrawerLink: (params) => new BuiltRoute(exports.OrganizationRoutes.Companies).addSearchParams({ crmCompanyId: params.crmCompanyId }),
    buildHouseholdDrawerLink: (params) => new BuiltRoute(exports.OrganizationRoutes.Contacts).addSearchParams({ crmHouseholdId: params.crmHouseholdId }),
    buildContactsFilteredByImportLink: (params) => new BuiltRoute(exports.OrganizationRoutes.Contacts).addSearchParams({ importId: params.importId }),
    buildPaymentsFilteredByImportLink: (params) => new BuiltRoute(exports.OrganizationRoutes.Payments).addSearchParams({ importId: params.importId }),
    buildEmailDeliveryPageLink: (params) => {
        const route = (0, exports.buildPathFromTemplate)(`${exports.OrganizationRoutes.Emails}[/:emailDeliveryId]`, {
            emailDeliveryId: params?.emailDeliveryId ?? null,
        });
        if (params?.statuses?.length) {
            route.addSearchParams({ statuses: params.statuses.join(",") });
        }
        return route;
    },
    buildSmsDeliveryPageLink: (params) => {
        const route = (0, exports.buildPathFromTemplate)(`${exports.OrganizationRoutes.Sms}[/:smsDeliveryId]`, {
            smsDeliveryId: params?.smsDeliveryId ?? null,
        });
        if (params?.statuses?.length) {
            route.addSearchParams({ statuses: params.statuses.join(",") });
        }
        return route;
    },
    buildOrganizationPageEditLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/o/organization-page/edit`, params),
    buildPostMailDeliveriesPageLink: (params) => (0, exports.buildPathFromTemplate)(`${exports.OrganizationRoutes.PostMail}[/:postMailDeliveryId]`, {
        postMailDeliveryId: params?.postMailDeliveryId ?? null,
    }),
    buildPostMailDeliveryEditorLink: (params) => new BuiltRoute(exports.OrganizationRoutes.PostMailEditor).addSearchParams({
        postMailDeliveryId: params.postMailDeliveryId,
    }),
    buildSettingsPageLink: (params) => new BuiltRoute(exports.OrganizationRoutes.Settings).addSearchParams({
        emailContentId: params.emailContentId ?? "",
        onboardCustomDomain: params.onboardCustomDomain ?? "",
        openIntegrations: params.openIntegrations ? "true" : "",
    }),
    buildCrmWorkflowEditLink: (params) => new BuiltRoute(exports.OrganizationRoutes.CrmWorkflowEdit).addSearchParams({
        workflowId: params.workflowId,
        ...(params.onExitUrl ? { onExitUrl: params.onExitUrl } : {}),
    }),
    buildCrmWorkflowLink: (params) => (0, exports.buildPathFromTemplate)(exports.OrganizationRoutes.CrmWorkflow, { workflowId: params.workflowId }),
    buildFullScreenEmailEditorLink: (params) => new BuiltRoute(exports.OrganizationRoutes.FullScreenEmailEditor).addSearchParams({
        emailContentId: params.emailContentId,
        ...(params.onExitUrl ? { onExitUrl: params.onExitUrl } : {}),
        ...(params.shouldShowAnimation ? { shouldShowAnimation: "true" } : {}),
        ...(params.skipTemplateStep ? { skipTemplateStep: "true" } : {}),
    }),
    buildEmailTemplateEditorLink: (params) => new BuiltRoute(exports.OrganizationRoutes.EmailTemplateEditor).addSearchParams({
        ...(params.templateId ? { templateId: params.templateId } : {}),
        ...(params.waypointTemplateKey ? { waypointTemplateKey: params.waypointTemplateKey } : {}),
        ...(params.onExitUrl ? { onExitUrl: params.onExitUrl } : {}),
        ...(params.onBackUrl ? { onBackUrl: params.onBackUrl } : {}),
    }),
    buildEmailTemplatesPageLink: (params) => new BuiltRoute(exports.OrganizationRoutes.EmailTemplates).addSearchParams(params?.templateFilter ? { templateFilter: params.templateFilter } : {}),
    buildEmailAiCreationPageLink: (params) => new BuiltRoute(exports.OrganizationRoutes.EmailAiCreation).addSearchParams(buildMagicEmailSearchParams(params)),
    buildEmailImportPageLink: (params) => new BuiltRoute(exports.OrganizationRoutes.EmailImport).addSearchParams(buildMagicEmailSearchParams(params)),
    buildDashboardReferralPageLink: () => new BuiltRoute(exports.OrganizationRoutes.Referral),
    buildReferralLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]${exports.PublicRoutes.Referral}`, { isoLocale: params.isoLocale }).addSearchParams({
        referredByOrganizationId: params.referredByOrganizationId ?? "",
    }),
    buildSignUpLink: () => new BuiltRoute(DashboardRoutes.SignUp),
    buildSignUpUserInfoLink: (params) => new BuiltRoute(DashboardRoutes.SignUpUserInfo).addSearchParams({
        ...(params?.email ? { email: params?.email } : {}),
    }),
    buildSignUpEligibilityLink: () => new BuiltRoute(DashboardRoutes.SignUpEligibility),
    buildSignUpOrganizationLink: () => new BuiltRoute(DashboardRoutes.SignUpOrganization),
    buildSignUpQualificationLink: () => new BuiltRoute(DashboardRoutes.SignUpQualification),
    buildSignInLink: (params) => new BuiltRoute(DashboardRoutes.SignIn).addSearchParams({
        ...(params?.email ? { email: params?.email } : {}),
        ...(params?.linkSent ? { [exports.SignInQueryParams.LinkSent]: params.linkSent } : {}),
    }),
    buildDonorSignInLink: (params) => new BuiltRoute(DashboardRoutes.DonorSignIn).addSearchParams({
        email: params.email,
        ...(params.linkSent ? { [exports.SignInQueryParams.LinkSent]: params.linkSent } : {}),
    }),
    buildTipRefundPageLink: (params) => (0, exports.buildPathFromTemplate)(`/:isoLocale/tip-refund`, params).addSearchParams({ token: params.token }),
    buildChangeContributionPageLink: (params) => (0, exports.buildPathFromTemplate)(`/:isoLocale/change-contribution`, params).addSearchParams({ token: params.token }),
    buildTaxReceiptsPageLink: (params) => (0, exports.buildPathFromTemplate)(`/:isoLocale/tax-receipts`, params).addSearchParams({ token: params.token }),
    buildManageRecurringDonationLink: (params) => `${(0, exports.buildPathFromTemplate)(`/:isoLocale/manage-recurring-donation`, params).toString()}#token=${encodeURIComponent(params.token)}`,
    buildPaymentMethodUpdateLink: (params) => `${(0, exports.buildPathFromTemplate)(`/:isoLocale/update-payment-method`, params).toString()}#token=${encodeURIComponent(params.token)}`,
    buildDonorPaymentDrawerLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/d/payments`, params).addSearchParams({
        commandId: params.commandId,
        ...(params.control ? { [exports.DONOR_PAYMENT_DRAWER_CONTROL_QUERY_PARAM]: params.control } : {}),
    }),
    buildPayoutTransactionsLink: (params) => (0, exports.buildPathFromTemplate)(`[/:isoLocale]/o/bank/payouts/transactions`, params).addSearchParams({
        payoutId: params.payoutId,
    }),
    buildInvoicePageLink: (params) => new BuiltRoute(`/invoice/${params.transactionId}`),
    buildPaymentPageLink: (params) => new BuiltRoute(`/payment/${params.transactionId}`),
};
/**
 * @deprecated Use RouteBuilders instead.
 */
var FrontendRoutes;
(function (FrontendRoutes) {
    FrontendRoutes["DonationFormPage"] = "/donation-form/";
    FrontendRoutes["PeerToPeerPage"] = "/peer-to-peer/";
    FrontendRoutes["FundraisingPage"] = "/fundraising/";
    FrontendRoutes["Landing"] = "/landing";
    FrontendRoutes["OrganizationPage"] = "/organizations/";
    FrontendRoutes["LeaderBoard"] = "/leaderboard/";
    FrontendRoutes["NotFound"] = "/404";
    FrontendRoutes["PeerToPeerSuccess"] = "/peer-to-peer-success";
    FrontendRoutes["TeamPage"] = "/team/";
    FrontendRoutes["ThankYou"] = "/thank-you";
    FrontendRoutes["EmbedThankYou"] = "/embed/thank-you";
    FrontendRoutes["Thermometer"] = "/thermometer/";
    FrontendRoutes["LiveThermometer"] = "/live/thermometer/";
    FrontendRoutes["Ticket"] = "/ticket/";
    FrontendRoutes["TicketingPage"] = "/ticketing/";
    FrontendRoutes["ThreeDSecureSuccess"] = "/three-d-secure-succeed";
    FrontendRoutes["NotFoundBug"] = "/404bug";
    FrontendRoutes["PostFormSubmit"] = "/post-form-submit";
    FrontendRoutes["MembershipCard"] = "/membership/member-info";
    FrontendRoutes["NewsletterFormPage"] = "/newsletter-form/";
    FrontendRoutes["TipRefundPage"] = "/tip-refund";
    FrontendRoutes["TaxReceiptsPage"] = "/tax-receipts";
    FrontendRoutes["EventTickets"] = "/event-tickets/";
    FrontendRoutes["ManageRecurringDonation"] = "/manage-recurring-donation";
})(FrontendRoutes || (exports.FrontendRoutes = FrontendRoutes = {}));
/**
 * @deprecated Use RouteBuilders instead.
 */
var DashboardRoutes;
(function (DashboardRoutes) {
    DashboardRoutes["DonationFormsNew"] = "/donations/forms/new";
    DashboardRoutes["DonationFormsV2New"] = "/donations/formsV2/new";
    DashboardRoutes["DonationFormsEdit"] = "/donations/forms/edit?donationFormId=:id";
    DashboardRoutes["FundraiserFormsEdit"] = "/fundraiser/forms/edit?donationFormId=:id";
    DashboardRoutes["ReceiptGeneration"] = "/receipts/new";
    DashboardRoutes["NotFound"] = "/404";
    DashboardRoutes["Bank"] = "/bank";
    DashboardRoutes["Payouts"] = "/bank/payouts";
    DashboardRoutes["PowerBalancePromo"] = "/bank/power-balance-promo";
    DashboardRoutes["Transactions"] = "/bank/transactions";
    DashboardRoutes["QuickBooks"] = "/bank/quickbooks";
    DashboardRoutes["PayoutTransactions"] = "/bank/payouts/transactions?payoutId=:id";
    DashboardRoutes["TicketingNew"] = "/tickets/forms/new";
    DashboardRoutes["TicketingEdit"] = "/tickets/forms/edit?ticketingId=:id";
    DashboardRoutes["CheckinManager"] = "/checkin-manager/:token";
    DashboardRoutes["TicketScanned"] = "/ticket/:id";
    DashboardRoutes["DonorPaymentTable"] = "/payments";
    DashboardRoutes["Contacts"] = "/crm/contacts";
    DashboardRoutes["Companies"] = "/crm/companies";
    DashboardRoutes["Emails"] = "/communication/bulk-emails";
    DashboardRoutes["Sms"] = "/communication/sms";
    DashboardRoutes["SignIn"] = "/login";
    DashboardRoutes["DonorSignIn"] = "/donor-login";
    DashboardRoutes["SignOut"] = "/logout";
    DashboardRoutes["SignUp"] = "/register";
    DashboardRoutes["SignUpUserInfo"] = "/register/user-info";
    DashboardRoutes["SignUpEligibility"] = "/register/eligibility";
    DashboardRoutes["SignUpOrganization"] = "/register/organization";
    DashboardRoutes["SignUpQualification"] = "/register/qualification";
    DashboardRoutes["SignUpReferral"] = "/register/referral";
    DashboardRoutes["SignUpReferralUserInfo"] = "/register/referral/user-info";
    DashboardRoutes["SignUpReferralEligibility"] = "/register/referral/eligibility";
    DashboardRoutes["SignUpReferralOrganization"] = "/register/referral/organization";
    DashboardRoutes["SignUpReferralQualification"] = "/register/referral/qualification";
    DashboardRoutes["SignUpPostDemo"] = "/register-post-demo";
    DashboardRoutes["ResetPassword"] = "/reset-password";
    DashboardRoutes["CreatePassword"] = "/create-password";
    DashboardRoutes["JoinOrganization"] = "/join";
    DashboardRoutes["CreateNewOrganization"] = "/organization/new";
    DashboardRoutes["CreateBankAccount"] = "/bank/account/create";
    DashboardRoutes["MergeUsers"] = "/merge-users";
    DashboardRoutes["VerifyEmail"] = "/verify-email";
    DashboardRoutes["UpdateBankAccount"] = "/bank/account/update";
    DashboardRoutes["Referral"] = "/referral";
    DashboardRoutes["Settings"] = "/settings";
    DashboardRoutes["Integrations"] = "/settings/integrations";
    DashboardRoutes["TapToPayInvitation"] = "/tap-to-pay-invitation";
    DashboardRoutes["DonorCampaigns"] = "/campaigns";
    DashboardRoutes["FormsNew"] = "/forms/new";
    DashboardRoutes["Commands"] = "/commands";
    DashboardRoutes["SwitchOrgAdmin"] = "/admin/switch-org";
    DashboardRoutes["SignInAdmin"] = "/admin/login";
    DashboardRoutes["MagicLoginAdmin"] = "/admin/magic-login";
    DashboardRoutes["Metrics"] = "/admin/metrics";
    DashboardRoutes["Import"] = "/import";
    DashboardRoutes["ImportLoading"] = "/import/loading";
    DashboardRoutes["Unsubscribe"] = "/unsubscribe";
    DashboardRoutes["NewsletterConfirmation"] = "/newsletter-confirmation";
    DashboardRoutes["UnsubscribeOrganizationUser"] = "/unsubscribe-organization-user";
    DashboardRoutes["StripeOnboarding"] = "/stripe-onboarding";
    DashboardRoutes["Insights"] = "/insights";
    DashboardRoutes["AllInsightsMembers"] = "/insights/members";
    DashboardRoutes["AllInsightsRecurring"] = "/insights/recurring";
    DashboardRoutes["Sandbox"] = "/sandbox";
    DashboardRoutes["Qa"] = "/qa";
    DashboardRoutes["IssuingOnboarding"] = "/issuing-onboarding";
    DashboardRoutes["ExpiredBidderLink"] = "/auction/expired-bidder-link";
    DashboardRoutes["ImportGMailContacts"] = "/sso/import-gmail-contacts";
    DashboardRoutes["ImportMailChimpContacts"] = "/sso/import-mailchimp-contacts";
    DashboardRoutes["GivingTuesdayMap"] = "/giving-tuesday/map";
    DashboardRoutes["FullScreenEmailEditor"] = "/emailing/full-screen-email-editor";
    DashboardRoutes["EmailTemplateEditor"] = "/emailing/template-editor";
    DashboardRoutes["EmailAiCreation"] = "/emailing/ai-create";
    DashboardRoutes["EmailImport"] = "/emailing/import";
    DashboardRoutes["EmailTemplates"] = "/communication/bulk-emails/templates";
    DashboardRoutes["TicketingV2New"] = "/tickets/formsV2/new";
    DashboardRoutes["Accounts"] = "/bank/accounts";
    DashboardRoutes["Campaigns"] = "/fundraising/campaigns";
    DashboardRoutes["CampaignHub"] = "/fundraising/campaigns/hub";
    DashboardRoutes["Payments"] = "/all-payments";
    DashboardRoutes["Receipts"] = "/bank/tax-receipts";
    DashboardRoutes["NewsletterCrossSell"] = "/crm/newsletter-cross-sell";
    DashboardRoutes["NewsletterForms"] = "/crm/forms";
    DashboardRoutes["NewsletterFormsNew"] = "/crm/forms/new";
    DashboardRoutes["NewsletterFormsEdit"] = "/crm/forms/edit?newsletterFormId=:id";
    DashboardRoutes["CrmWorkflowEdit"] = "/crm/workflows/edit";
    DashboardRoutes["CrmWorkflow"] = "/crm/workflow/:workflowId";
    DashboardRoutes["PostMail"] = "/communication/postal-mails";
    DashboardRoutes["PostMailEditor"] = "/communication/postal-mails/editor";
    DashboardRoutes["ContactLists"] = "/crm/lists";
    DashboardRoutes["ContactListsCreate"] = "/crm/lists/create";
    DashboardRoutes["ContactListsNew"] = "/crm/lists/new";
    DashboardRoutes["Members"] = "/crm/members";
    DashboardRoutes["SwiftAidOnboarding"] = "/swift-aid-onboarding";
    DashboardRoutes["G2Review"] = "/g2-review";
})(DashboardRoutes || (exports.DashboardRoutes = DashboardRoutes = {}));
exports.EMAIL_DRAFT_CARRYING_ROUTES = [
    DashboardRoutes.FullScreenEmailEditor,
    DashboardRoutes.EmailAiCreation,
    DashboardRoutes.EmailImport,
];
var MobileRoutes;
(function (MobileRoutes) {
    MobileRoutes["ResetPassword"] = "ResetPassword";
    MobileRoutes["PaymentItem"] = "PaymentItem";
})(MobileRoutes || (exports.MobileRoutes = MobileRoutes = {}));
var FormQueryParams;
(function (FormQueryParams) {
    FormQueryParams["Modal"] = "modal";
})(FormQueryParams || (exports.FormQueryParams = FormQueryParams = {}));
var PeerToPeerQueryParams;
(function (PeerToPeerQueryParams) {
    PeerToPeerQueryParams["OpenFundraiser"] = "openFundraiser";
    PeerToPeerQueryParams["OpenTeamCreation"] = "openTeamCreation";
    PeerToPeerQueryParams["OpenTeamJoin"] = "openTeamJoin";
    PeerToPeerQueryParams["DefaultFundraiserTarget"] = "target";
})(PeerToPeerQueryParams || (exports.PeerToPeerQueryParams = PeerToPeerQueryParams = {}));
const getPathWithLocale = (path, isoLocale) => {
    return isoLocale ? `/${isoLocale}${path}` : path;
};
const getFormLink = (donationForm, isoLocale) => {
    if (donationForm.category === enums_1.DonationFormCategory.PeerToPeerCampaign) {
        return exports.RouteBuilders.buildPeerToPeerV2CampaignLink({
            type: donationForm.isPrimaryCampaign ? "general" : donationForm.isPrimaryTeam ? "team" : "individual",
            path: donationForm.path,
            isoLocale,
        }).path;
    }
    return exports.RouteBuilders.buildDonationFormLink({
        path: donationForm.path,
        isoLocale,
    }).path;
};
exports.getFormLink = getFormLink;
const getDonationOrTicketingFormLink = ({ form, isoLocale }) => {
    if (form.formType === enums_1.FormType.Ticketing) {
        return (0, exports.getTicketingLink)(form.path, isoLocale);
    }
    return (0, exports.getFormLink)({
        ...form,
        category: form.formCategory === enums_1.FormCategory.DonationForm
            ? enums_1.DonationFormCategory.DonationForm
            : enums_1.DonationFormCategory.PeerToPeerCampaign,
    }, isoLocale);
};
exports.getDonationOrTicketingFormLink = getDonationOrTicketingFormLink;
const getDonationOrTicketingEmbedLink = ({ form, isoLocale }) => {
    if (form.formType === enums_1.FormType.Ticketing) {
        return (0, exports.getEmbedTicketingLink)(form.path, isoLocale);
    }
    return (0, exports.getEmbedFormLink)({
        ...form,
        category: form.formCategory === enums_1.FormCategory.DonationForm
            ? enums_1.DonationFormCategory.DonationForm
            : enums_1.DonationFormCategory.PeerToPeerCampaign,
    }, isoLocale);
};
exports.getDonationOrTicketingEmbedLink = getDonationOrTicketingEmbedLink;
const getEmbedFormLink = (donationForm, isoLocale) => {
    return exports.RouteBuilders.buildEmbedDonationFormLink({
        isoLocale,
        path: donationForm.path,
    }).path;
};
exports.getEmbedFormLink = getEmbedFormLink;
const getEmbedThermometerLink = (path, isoLocale) => {
    return getPathWithLocale(`/embed${FrontendRoutes.Thermometer}${path}`, isoLocale);
};
exports.getEmbedThermometerLink = getEmbedThermometerLink;
const getLiveThermometerLink = (path, isoLocale) => {
    return getPathWithLocale(`${FrontendRoutes.LiveThermometer}${path}`, isoLocale);
};
exports.getLiveThermometerLink = getLiveThermometerLink;
const getEmbedLeaderboardLink = (path, isoLocale) => {
    return getPathWithLocale(`/embed${FrontendRoutes.LeaderBoard}${path}`, isoLocale);
};
exports.getEmbedLeaderboardLink = getEmbedLeaderboardLink;
const getTicketingLink = (path, isoLocale) => {
    return getPathWithLocale(`${FrontendRoutes.TicketingPage}${path}`, isoLocale);
};
exports.getTicketingLink = getTicketingLink;
const getOrganizationPageLink = (path, isoLocale) => {
    return getPathWithLocale(`${FrontendRoutes.OrganizationPage}${path}`, isoLocale);
};
exports.getOrganizationPageLink = getOrganizationPageLink;
const getOrganizationPageNewsletterUrl = (organizationPageUrl, newsletterId) => `${organizationPageUrl}/newsletters/${newsletterId}`;
exports.getOrganizationPageNewsletterUrl = getOrganizationPageNewsletterUrl;
const getOrganizationPageFullUrl = ({ frontendUrl, country, locale, organizationPagePath, }) => {
    const isoLocale = (0, locales_1.getIsoLocaleFromCountry)(country, locale);
    return `${frontendUrl}${(0, exports.getOrganizationPageLink)(organizationPagePath, isoLocale)}`;
};
exports.getOrganizationPageFullUrl = getOrganizationPageFullUrl;
const getEmbedTicketingLink = (path, isoLocale, params) => {
    const queryParams = params ? `?${(0, query_string_1.stringify)(params || {})}` : "";
    return getPathWithLocale(`/embed${FrontendRoutes.TicketingPage}${path}${queryParams}`, isoLocale);
};
exports.getEmbedTicketingLink = getEmbedTicketingLink;
const getTeamLink = (path, isoLocale) => {
    if (!path) {
        return null;
    }
    return `/${isoLocale}${FrontendRoutes.TeamPage}${path}`;
};
exports.getTeamLink = getTeamLink;
const getIndividualFundraisingLink = (path, isoLocale) => {
    if (!path) {
        return null;
    }
    return exports.RouteBuilders.buildDonationFormLink({
        isoLocale,
        path,
    }).path;
};
exports.getIndividualFundraisingLink = getIndividualFundraisingLink;
exports.SHOW_SUCCESS_BANK_MODALE_QUERY_PARAM = "showSuccessBankModal";
exports.IS_SUPER_ADMIN_QUERY_PARAM = "isSuperAdmin";
exports.RESET_PASSWORD_LINK_CONTEXT_QUERY_PARAM = "link";
const formatResetPasswordLinkContext = ({ isPasswordCreation, isDonorAccount, expiresAt, }) => [isPasswordCreation ? "creation" : "reset", isDonorAccount ? "donor" : "standard", expiresAt].join(".");
exports.formatResetPasswordLinkContext = formatResetPasswordLinkContext;
const parseResetPasswordLinkContext = (value) => {
    const [purpose, audience, expiresAt] = value?.split(".") ?? [];
    const expiresAtMs = Number(expiresAt);
    if (!["creation", "reset"].includes(purpose) || !["donor", "standard"].includes(audience) || !expiresAtMs) {
        return null;
    }
    return { isPasswordCreation: purpose === "creation", isDonorAccount: audience === "donor", expiresAt: expiresAtMs };
};
exports.parseResetPasswordLinkContext = parseResetPasswordLinkContext;
exports.DONOR_PAYMENT_DRAWER_CONTROL_QUERY_PARAM = "control";
exports.SignInQueryParams = {
    LinkSent: "linkSent",
};
var CampaignPaymentTab;
(function (CampaignPaymentTab) {
    CampaignPaymentTab["Overview"] = "overview";
    CampaignPaymentTab["Payment"] = "payment";
    CampaignPaymentTab["Guest"] = "guest";
    CampaignPaymentTab["Fulfillment"] = "fulfillment";
    CampaignPaymentTab["Member"] = "member";
    CampaignPaymentTab["Communication"] = "communication";
    CampaignPaymentTab["Product"] = "product";
    CampaignPaymentTab["ProductBid"] = "product-bid";
    CampaignPaymentTab["Todos"] = "todos";
})(CampaignPaymentTab || (exports.CampaignPaymentTab = CampaignPaymentTab = {}));
/** @deprecated Use RouteBuilders instead */
exports.OrganizationRoutes = Object.fromEntries(Object.entries(DashboardRoutes).map(([key, value]) => [key, RoutePrefix.Organization + value]));
/** @deprecated Use RouteBuilders instead */
exports.DonorRoutes = Object.fromEntries(Object.entries(DashboardRoutes).map(([key, value]) => [key, RoutePrefix.Donor + value]));
/** @deprecated Use RouteBuilders instead */
exports.PublicRoutes = Object.fromEntries(Object.entries(DashboardRoutes).map(([key, value]) => [key, value]));
